/**
 * fetchWhoami — REST call for GET /whoami, used to decide whether the
 * signed-in user should see the admin entry point in the sidebar.
 *
 * The frontend has no legitimate way to know the backend's ADMIN_ALIASES
 * list, and must not infer admin status from anything decoded locally out
 * of the ID token (e.g. App.tsx's getUserAlias()) -- SodaBrainFargateAgent
 * is the only place that list lives, so this is a real network round-trip,
 * not a client-side check (specs/open/feedback-submissions-management.md).
 */
import { authService } from './auth';
import { API_URL } from './common/constants';
import { fetchJson } from './fetchJson';

/** Fetch whether the signed-in user is an admin. Throws if there's no valid token or the request fails. */
export async function fetchWhoami(): Promise<{ isAdmin: boolean }> {
  return fetchJson<{ isAdmin: boolean }>(`${API_URL}/whoami`, authService.getIdToken(), 'whoami');
}
